export const objectFilterByValue = <T>(obj: {}, value: any):T => {
  const validValuesArray = Object.entries(obj).filter(
    (entry) => entry[1] !== value,
  )
  const validValuesFilters = Object.fromEntries(validValuesArray)
  return validValuesFilters as unknown as T
}
